<div class="card cert-filter">
  <h3>{{ "Cert.Chart.Filter" | translate }}</h3>

  <div class="cert-filter__form-row">
    <label for="" class="form-label">{{ "Cert.Filter.IPPrefixes" | translate }}</label>
    <custom-dropdown [options]="prefixOptions()"></custom-dropdown>
  </div>

  <div class="cert-filter__form-row">
    <label for="" class="form-label">{{ "Cert.IPAddress" | translate }}</label>
    <input
      type="text"
      class="input"
      [(ngModel)]="ip"
      placeholder="{{ 'Cert.Filter.IPAddress.Placeholder' | translate }}"
    />
  </div>

  <div class="cert-filter__form-row">
    <label for="" class="form-label">{{ "Cert.RPZFeed" | translate }}</label>
    <custom-dropdown [options]="rpzFeedOptions()"></custom-dropdown>
  </div>

  <div class="cert-filter__form-row">
    <label for="" class="form-label">{{ "Cert.Period" | translate }}</label>
    <div class="cert-filter__date-split">
      <div class="cert-filter__date-input">
        <input
          type="text"
          id="startDate"
          mwlFlatpickr
          [dateFormat]="'d-m-Y'"
          [convertModelValue]="true"
          [disableMobile]="true"
          [(ngModel)]="initialStartDate"
        />
        <svg-icon class="cert-filter__date-input-icon" src="assets/images/icons/select-calendar.svg"> </svg-icon>
      </div>
      <div class="cert-filter__date-input">
        <input
          type="text"
          id="endDate"
          mwlFlatpickr
          [dateFormat]="'d-m-Y'"
          [convertModelValue]="true"
          [disableMobile]="true"
          [(ngModel)]="initialEndDate"
        />
        <svg-icon class="cert-filter__date-input-icon" src="assets/images/icons/select-calendar.svg"> </svg-icon>
      </div>
    </div>
  </div>

  <div class="cert-filter__form-footer">
    <div class="cert-filter__reset" (click)="resetFilters()">{{ "Global.Action.Reset" | translate }}</div>
    <button (click)="submit()" class="button button--primary">{{ "Global.Action.Filter" | translate }}</button>
  </div>
</div>
